module.exports = __webpack_public_path__ + "img/KSAT25-45-1000-3-btn.9e12323e.png";